export default "__VITE_ASSET__DChAwX_3__"